import Base from "./base"

export default class TalkRoomExists extends Base {
  constructor(Vue, store) {
    super("talk-room-exists", Vue, store)
  }

  async before(to, from, next) {
    console.log("talk-room-exists")
    const event = this.store.getters["event/event"]
    const room = to.params.roomName

    await this.vm.prototype.$axios
      .get(`events/${event.slug}/talk_rooms/${room}/exists`)
      .then(response => {
        if (response.data) {
          next()
        } else {
          next({name: "Top", params: {slug: from.params.slug || to.params.slug}})
        }
      })
      .catch(error => {
        console.error(error)
        // APIがエラーを返した場合はTOPへリダイレクト
        next({name: "Top", params: {slug: from.params.slug || to.params.slug}})
      })
  }
}
